import { AlertColor } from '@mui/material'
import { Location } from './wotcApplicantState'
import { atom } from 'recoil'

export type WotcConfig = {
  clientId: string
  active: boolean
  organizationCode?: string
  providerName?: string
  marketIntegration?: boolean
  selectedProvider?: string,
  selectedOrganizationCode?: string,
  selectedLocationId: string,
  selectedLocation?: Location,
  legacyClientId?: number,
  locations?: ProviderLocations[]
}

export type CCTConfig = {
  showAlert: boolean;
  isUpdate: boolean;
  alertTitle?: string;
  alertMessage?: string;
  alertSeverity?: AlertColor;
  orgError: boolean;
  locationError: boolean
  vendorListError: boolean;
  allLocations: Location[];
}

const wotcConfig = {  
  active: false,
  clientId: '',    
  legacyClientId: 0,
  locations: [],
  marketIntegration: false,
  organizationCode: '',
  providerName: '',
  selectedLocationId: '',
  selectedOrganizationCode: '',
  selectedProvider: ''
  
} as WotcConfig

const cctConfig = {
  allLocations: [],
  isUpdate: false,
  locationError: false,
  showAlert: false
} as CCTConfig

export type ProviderLocations = {
  id: string;
  providerLocationId: string;
}


const wotcConfigState = atom({
  default: { cctConfig, wotcConfig },
  key: 'wotcState',
})

export default wotcConfigState